import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAnnotation = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			rx: 4,
			fill: "currentColor",
			fillOpacity: .2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 5,
			y: 5,
			width: 10,
			height: 10,
			fill: "currentColor",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 6,
			y: 6,
			width: 8,
			height: 8,
			stroke: "currentColor",
			strokeOpacity: .3,
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 12,
			y: 12,
			width: 4,
			height: 4,
			rx: 2,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 4,
			y: 12,
			width: 4,
			height: 4,
			rx: 2,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 12,
			y: 4,
			width: 4,
			height: 4,
			rx: 2,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 4,
			y: 4,
			width: 4,
			height: 4,
			rx: 2,
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgAnnotation);
export { ForwardRef as ReactComponent };
